import { useTranslation } from 'react-i18next';

import giftBoxImg from '../../../assets/gift/green-present-box.png';
import styles from '../Onboarding.module.scss';

export const BonusTooltip = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.bonusTooltip}>
      <p className={styles.bonusTooltipText}>
        <span>{t('onboarding.clickToClaim')} </span>
        <strong>{t('onboarding.dailyBonus')} </strong>
      </p>
      <img alt="gift box" src={giftBoxImg} />
    </div>
  );
};
